import React, { useEffect, useState } from 'react';
import './FormularioAutos.css';
import { AutosService } from '../services/autosService';
import { ChoferesService } from '../services/choferesService';

const FormularioAutos = () => {
  const [autos, setAutos] = useState([]);
  const [choferes, setChoferes] = useState([]);
  const [mostrarFormulario, setMostrarFormulario] = useState(true);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');
  const [exito, setExito] = useState('');
  const [autoEditando, setAutoEditando] = useState(null);

  const [filtros] = useState({
    query: '',
    estado: 'todos',
    chofer: 'todos'
  });
  const [vistaArea, setVistaArea] = useState('todos'); // todos | proveedor | reparto | empleado

  // Campos adicionales agregados al formulario
  const [form, setForm] = useState({
    placas: '',
    marca: '',
    modelo: '',
    anio: '',
    color: '',
    capacidad: '',
    seguro: '',
    vignete: '',
    fechaMantenimiento: '',
    choferAsignado: '',
    estado: 'disponible',
    areaVehicular: '',
    nombreProveedor: '',
    telefonoProveedor: '',
    nombreEmpleado: '',
    numeroEmpleado: ''
  });

  // Reglas de requeridos por área
  const REQUIRED_BY_AREA = {
    proveedor: ['nombreProveedor', 'telefonoProveedor'],
    reparto: ['placas', 'marca', 'modelo', 'anio', 'color', 'capacidad', 'seguro'],
    empleado: ['nombreEmpleado', 'numeroEmpleado', 'placas', 'marca']
  };

  useEffect(() => {
    const unsubscribeAutos = AutosService.suscribirseAutos((autosData) => {
      setAutos(autosData);
    });
    const unsubscribeChoferes = ChoferesService.suscribirseChoferes(setChoferes);
    return () => {
      if (typeof unsubscribeAutos === 'function') unsubscribeAutos();
      if (typeof unsubscribeChoferes === 'function') unsubscribeChoferes();
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
  // Limpieza condicional al cambiar el área vehicular
  if (name === 'areaVehicular') {
    setError('');
    setExito('');
    setForm((prev) => {
      const next = { ...prev, areaVehicular: value };
      // Siempre limpia campos que no aplican al cambiar de área
      if (value === 'proveedor') {
        next.nombreEmpleado = '';
        next.numeroEmpleado = '';
        next.choferAsignado = '';
      } else if (value === 'empleado') {
        next.nombreProveedor = '';
        next.telefonoProveedor = '';
        next.choferAsignado = '';
      } else if (value === 'reparto') {
        next.nombreProveedor = '';
        next.telefonoProveedor = '';
        next.nombreEmpleado = '';
        next.numeroEmpleado = '';
      } else {
        // Sin área: limpia todos los específicos
        next.nombreProveedor = '';
        next.telefonoProveedor = '';
        next.nombreEmpleado = '';
        next.numeroEmpleado = '';
        next.choferAsignado = '';
      }
      return next;
    });
    return;
  }
  setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setExito('');

    // Validación condicional por área
    if (!form.areaVehicular) {
      setError('Selecciona un área vehicular');
      return;
    }
    const required = REQUIRED_BY_AREA[form.areaVehicular] || [];
    const faltantes = required.filter((campo) => !String(form[campo] || '').trim());
    if (faltantes.length > 0) {
      setError('Completa los campos requeridos para esta área');
      return;
    }
    if (form.areaVehicular === 'reparto' && form.anio && !/^\d{4}$/.test(form.anio)) {
      setError('El año debe tener 4 dígitos');
      return;
    }

    try {
      setCargando(true);
      // Construir payload según área
      let dataAGuardar = { areaVehicular: form.areaVehicular, estado: form.estado };
      if (form.areaVehicular === 'proveedor') {
        dataAGuardar = {
          ...dataAGuardar,
          nombreProveedor: form.nombreProveedor.trim(),
          telefonoProveedor: form.telefonoProveedor.trim(),
          // limpiar no aplicables
          placas: '', marca: '', modelo: '', anio: null, color: '', capacidad: '', seguro: '', vignete: '', fechaMantenimiento: null, choferAsignado: '' ,
          nombreEmpleado: '', numeroEmpleado: ''
        };
      } else if (form.areaVehicular === 'empleado') {
        dataAGuardar = {
          ...dataAGuardar,
          nombreEmpleado: form.nombreEmpleado.trim(),
          numeroEmpleado: form.numeroEmpleado.trim(),
          placas: form.placas.trim().toUpperCase(),
          marca: form.marca.trim(),
          modelo: '', anio: null, color: '', capacidad: '', seguro: '', vignete: '', fechaMantenimiento: null, choferAsignado: '' ,
          nombreProveedor: '', telefonoProveedor: ''
        };
      } else if (form.areaVehicular === 'reparto') {
        dataAGuardar = {
          ...dataAGuardar,
          placas: form.placas.trim().toUpperCase(),
          marca: form.marca.trim(),
          modelo: form.modelo.trim(),
          anio: parseInt(form.anio, 10),
          color: form.color.trim(),
          capacidad: form.capacidad.trim(),
          seguro: form.seguro.trim(),
          vignete: form.vignete.trim(),
          fechaMantenimiento: form.fechaMantenimiento || null,
          choferAsignado: '' ,
          nombreProveedor: '', telefonoProveedor: '', nombreEmpleado: '', numeroEmpleado: ''
        };
      }

      if (autoEditando) {
        await AutosService.actualizarAuto(autoEditando.id, dataAGuardar);
        setExito('Auto actualizado correctamente');
      } else {
        await AutosService.crearAuto(dataAGuardar);
        setExito('Auto registrado correctamente');
      }

      setForm({
        placas: '',
        marca: '',
        modelo: '',
        anio: '',
        color: '',
        capacidad: '',
        seguro: '',
        vignete: '',
        fechaMantenimiento: '',
        choferAsignado: '',
        estado: 'disponible',
        areaVehicular: '',
        nombreProveedor: '',
        telefonoProveedor: '',
        nombreEmpleado: '',
        numeroEmpleado: ''
      });
      setAutoEditando(null);
    } catch (err) {
      setError('Error al guardar el auto');
      console.error(err);
    } finally {
      setCargando(false);
    }
  };

  const comenzarEdicion = (auto) => {
    setAutoEditando(auto);
    setMostrarFormulario(true);
    setForm({
      placas: auto.placas || '',
      marca: auto.marca || '',
      modelo: auto.modelo || '',
      anio: String(auto.anio || ''),
      color: auto.color || '',
      capacidad: auto.capacidad || '',
      seguro: auto.seguro || '',
      vignete: auto.vignete || '',
      fechaMantenimiento: auto.fechaMantenimiento || '',
      choferAsignado: auto.choferAsignado || '',
      estado: auto.estado || 'disponible',
      areaVehicular: auto.areaVehicular || '',
      nombreProveedor: auto.nombreProveedor || '',
      telefonoProveedor: auto.telefonoProveedor || '',
      nombreEmpleado: auto.nombreEmpleado || '',
      numeroEmpleado: auto.numeroEmpleado || ''
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const cancelarEdicion = () => {
    setAutoEditando(null);
    setForm({
      placas: '',
      marca: '',
      modelo: '',
      anio: '',
      color: '',
      capacidad: '',
      seguro: '',
      vignete: '',
      fechaMantenimiento: '',
      choferAsignado: '',
      estado: 'disponible',
      areaVehicular: '',
      nombreProveedor: '',
      telefonoProveedor: '',
      nombreEmpleado: '',
      numeroEmpleado: ''
    });
  };

  const eliminarAuto = async (auto) => {
    if (!window.confirm(`¿Eliminar el auto ${auto.placas}?`)) return;
    try {
      await AutosService.eliminarAuto(auto.id);
    } catch (err) {
      console.error(err);
      alert('No se pudo eliminar el auto');
    }
  };

  return (
    <div className='FormularioAutos'>
      <div className='header-section'>
        <h1>Registro de Autos</h1>
        {!mostrarFormulario && (
          <button className='btn-primary' onClick={() => setMostrarFormulario(true)}>
            Registrar Nuevo Auto
          </button>
        )}
      </div>

      {mostrarFormulario && (
        <form className='form-autos' onSubmit={handleSubmit}>
          {/* Selector de Área */}
          <div className='form-section'>
            <h3 className='form-section-title'>Selecciona el área</h3>
            <div className='form-grid'>
              <div className='form-row'>
                <label>Área vehicular *</label>
                <select name='areaVehicular' value={form.areaVehicular} onChange={handleChange} required>
                  <option value=''>Seleccionar área...</option>
                  <option value='proveedor'>Proveedores</option>
                  <option value='reparto'>Unidades de reparto</option>
                  <option value='empleado'>Empleados</option>
                </select>
              </div>
            </div>
          </div>

          {/* Formulario: Proveedor */}
          {form.areaVehicular === 'proveedor' && (
            <div className='form-section'>
              <h3 className='form-section-title'>Alta de Proveedor</h3>
              <div className='form-grid'>
                <div className='form-row'>
                  <label>Nombre del proveedor *</label>
                  <input name='nombreProveedor' value={form.nombreProveedor} onChange={handleChange} placeholder='Nombre del proveedor' />
                </div>
                <div className='form-row'>
                  <label>Teléfono del proveedor *</label>
                  <input name='telefonoProveedor' value={form.telefonoProveedor} onChange={handleChange} placeholder='Teléfono del proveedor' />
                </div>
              </div>
            </div>
          )}

          {/* Formulario: Reparto */}
          {form.areaVehicular === 'reparto' && (
            <>
              <div className='form-section'>
                <h3 className='form-section-title'>Datos del Vehículo (Reparto)</h3>
                <div className='form-grid'>
                  <div className='form-row'>
                    <label>Placas *</label>
                    <input name='placas' value={form.placas} onChange={handleChange} placeholder='ABC-123' />
                  </div>
                  <div className='form-row'>
                    <label>Marca *</label>
                    <input name='marca' value={form.marca} onChange={handleChange} placeholder='Toyota' />
                  </div>
                  <div className='form-row'>
                    <label>Modelo *</label>
                    <input name='modelo' value={form.modelo} onChange={handleChange} placeholder='Hilux' />
                  </div>
                  <div className='form-row'>
                    <label>Año *</label>
                    <input name='anio' value={form.anio} onChange={handleChange} placeholder='2022' maxLength={4} />
                  </div>
                  <div className='form-row'>
                    <label>Color *</label>
                    <input name='color' value={form.color} onChange={handleChange} placeholder='Blanco' />
                  </div>
                  <div className='form-row'>
                    <label>Capacidad de la unidad *</label>
                    <input name='capacidad' value={form.capacidad} onChange={handleChange} placeholder='Ej. 2 toneladas o 7 pasajeros' />
                  </div>
                  <div className='form-row'>
                    <label>Seguro *</label>
                    <input name='seguro' value={form.seguro} onChange={handleChange} placeholder='Número o nombre de póliza' />
                  </div>
                </div>
              </div>
              <div className='form-section'>
                <h3 className='form-section-title'>Documentación (opcional)</h3>
                <div className='form-grid'>
                  <div className='form-row'>
                    <label>Vignete</label>
                    <input name='vignete' value={form.vignete} onChange={handleChange} placeholder='Vigencia o identificación del vignete' />
                  </div>
                  <div className='form-row'>
                    <label>Fecha de mantenimiento</label>
                    <input type='date' name='fechaMantenimiento' value={form.fechaMantenimiento} onChange={handleChange} />
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Formulario: Empleado */}
          {form.areaVehicular === 'empleado' && (
            <div className='form-section'>
              <h3 className='form-section-title'>Asignación a Empleado</h3>
              <div className='form-grid'>
                <div className='form-row'>
                  <label>Placas *</label>
                  <input name='placas' value={form.placas} onChange={handleChange} placeholder='ABC-123' />
                </div>
                <div className='form-row'>
                  <label>Marca *</label>
                  <input name='marca' value={form.marca} onChange={handleChange} placeholder='Marca del auto' />
                </div>
                <div className='form-row'>
                  <label>Nombre completo *</label>
                  <input name='nombreEmpleado' value={form.nombreEmpleado} onChange={handleChange} placeholder='Nombre del empleado' />
                </div>
                <div className='form-row'>
                  <label>Número de empleado *</label>
                  <input name='numeroEmpleado' value={form.numeroEmpleado} onChange={handleChange} placeholder='Número de empleado' />
                </div>
              </div>
            </div>
          )}

          {/* Mensajes y acciones */}
          {error && <div className='form-error'>{error}</div>}
          {exito && <div className='form-success'>{exito}</div>}
          <div className='form-actions'>
            <button type='submit' className='btn-primary' disabled={cargando}>
              {cargando ? 'Guardando...' : (autoEditando ? 'Actualizar' : 'Guardar')}
            </button>
            {autoEditando ? (
              <button type='button' className='btn-secondary' onClick={cancelarEdicion}>Cancelar edición</button>
            ) : (
              <button type='button' className='btn-secondary' onClick={() => setMostrarFormulario(false)}>Cancelar</button>
            )}
          </div>
        </form>
      )}

      {/* Listado de Autos */}
      <div className='listado-autos'>
        <h2>Autos registrados</h2>
        <div className='filters-row'>
          <div className='form-row'>
            <label>Vista por área</label>
            <select value={vistaArea} onChange={(e) => setVistaArea(e.target.value)}>
              <option value='todos'>Todas</option>
              <option value='proveedor'>Proveedores</option>
              <option value='reparto'>Reparto</option>
              <option value='empleado'>Empleados</option>
            </select>
          </div>
        </div>
        
        {/* Vista de tabla para desktop */}
        <div className='tabla-autos-wrapper hidden-sm'>
          {(() => {
            const lista = autos
              .filter((a) => (vistaArea === 'todos' ? true : a.areaVehicular === vistaArea))
              .filter((a) => {
                const q = filtros.query.toLowerCase();
                const coincideTexto =
                  !q ||
                  a.placas?.toLowerCase().includes(q) ||
                  a.marca?.toLowerCase().includes(q) ||
                  a.modelo?.toLowerCase().includes(q) ||
                  a.nombreProveedor?.toLowerCase().includes(q) ||
                  a.nombreEmpleado?.toLowerCase().includes(q);
                const coincideEstado = filtros.estado === 'todos' || a.estado === filtros.estado;
                return coincideTexto && coincideEstado;
              });

            if (lista.length === 0) {
              return <div className='text-center text-muted'>Sin registros</div>;
            }

            const Table = ({ children }) => (
              <table className='table-autos'>
                {children}
              </table>
            );

            if (vistaArea === 'proveedor') {
              return (
                <Table>
                  <thead>
                    <tr>
                      <th>Nombre del proveedor</th>
                      <th>Teléfono</th>
                      <th>Estado</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lista.map((a) => (
                      <tr key={a.id}>
                        <td>{a.nombreProveedor || '—'}</td>
                        <td>{a.telefonoProveedor || '—'}</td>
                        <td>
                          <span className={`estado-badge ${a.estado === 'disponible' || a.estado === 'activo' ? 'disponible' : 'no-disponible'}`}>
                            {a.estado === 'disponible' || a.estado === 'activo' ? 'Disponible' : 'No disponible'}
                          </span>
                        </td>
                        <td>
                          <div className='acciones-tabla'>
                            <button className='btn-editar' onClick={() => comenzarEdicion(a)}>Editar</button>
                            <button className='btn-eliminar' onClick={() => eliminarAuto(a)}>Eliminar</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              );
            }

            if (vistaArea === 'empleado') {
              return (
                <Table>
                  <thead>
                    <tr>
                      <th>Nombre del empleado</th>
                      <th>Número de empleado</th>
                      <th>Estado</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lista.map((a) => (
                      <tr key={a.id}>
                        <td>{a.nombreEmpleado || '—'}</td>
                        <td>{a.numeroEmpleado || '—'}</td>
                        <td>
                          <span className={`estado-badge ${a.estado === 'disponible' || a.estado === 'activo' ? 'disponible' : 'no-disponible'}`}>
                            {a.estado === 'disponible' || a.estado === 'activo' ? 'Disponible' : 'No disponible'}
                          </span>
                        </td>
                        <td>
                          <div className='acciones-tabla'>
                            <button className='btn-editar' onClick={() => comenzarEdicion(a)}>Editar</button>
                            <button className='btn-eliminar' onClick={() => eliminarAuto(a)}>Eliminar</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              );
            }

            // Reparto (por defecto o seleccionado)
            return (
              <Table>
                <thead>
                  <tr>
                    <th>Placas</th>
                    <th>Marca</th>
                    <th>Modelo</th>
                    <th>Año</th>
                    <th>Color</th>
                    <th>Capacidad</th>
                    <th>Seguro</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {lista
                    .filter((a) => vistaArea === 'todos' ? a.areaVehicular === 'reparto' || true : true)
                    .map((a) => (
                      <tr key={a.id}>
                        <td>{a.placas || '—'}</td>
                        <td>{a.marca || '—'}</td>
                        <td>{a.modelo || '—'}</td>
                        <td>{a.anio || '—'}</td>
                        <td>{a.color || '—'}</td>
                        <td>{a.capacidad || '—'}</td>
                        <td>{a.seguro || '—'}</td>
                        <td>
                          <span className={`estado-badge ${a.estado === 'disponible' || a.estado === 'activo' ? 'disponible' : 'no-disponible'}`}>
                            {a.estado === 'disponible' || a.estado === 'activo' ? 'Disponible' : 'No disponible'}
                          </span>
                        </td>
                        <td>
                          <div className='acciones-tabla'>
                            <button className='btn-editar' onClick={() => comenzarEdicion(a)}>Editar</button>
                            <button className='btn-eliminar' onClick={() => eliminarAuto(a)}>Eliminar</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            );
          })()}
        </div>

        {/* Vista de tarjetas para móviles */}
        <div className='mobile-card-view hidden-md'>
          {autos.length === 0 && (
            <div className='text-center text-muted mt-2'>Sin registros</div>
          )}
          {autos
            .filter((a) => {
              if (vistaArea !== 'todos' && a.areaVehicular !== vistaArea) return false;
              const q = filtros.query.toLowerCase();
              const coincideTexto =
                !q ||
                a.placas?.toLowerCase().includes(q) ||
                a.marca?.toLowerCase().includes(q) ||
                a.modelo?.toLowerCase().includes(q) ||
                a.nombreProveedor?.toLowerCase().includes(q) ||
                a.nombreEmpleado?.toLowerCase().includes(q);
              const coincideEstado = filtros.estado === 'todos' || a.estado === filtros.estado;
              return coincideTexto && coincideEstado;
            })
            .map((a) => {
              const chofer = choferes.find(c => c.id === a.choferAsignado);
              
              // Función para obtener información específica según el área
              const getInfoEspecifica = (auto) => {
                switch (auto.areaVehicular) {
                  case 'proveedor':
                    return `${auto.nombreProveedor || '—'} (${auto.telefonoProveedor || '—'})`;
                  case 'empleado':
                    return `${auto.nombreEmpleado || '—'} (${auto.numeroEmpleado || '—'})`;
                  case 'reparto':
                    return 'Unidad de reparto';
                  default:
                    return '—';
                }
              };

              // Función para obtener el nombre del área
              const getAreaVehicular = (area) => {
                switch (area) {
                  case 'proveedor':
                    return 'Proveedores';
                  case 'empleado':
                    return 'Empleados';
                  case 'reparto':
                    return 'Reparto';
                  default:
                    return '—';
                }
              };

              return (
                <div key={a.id} className='mobile-card'>
                  <div className='mobile-card-header'>
                    <div className='mobile-card-title'>{a.placas}</div>
                    <span className={`estado-badge ${a.estado === 'disponible' || a.estado === 'activo' ? 'disponible' : 'no-disponible'}`}>
                      {a.estado === 'disponible' || a.estado === 'activo' ? 'Disponible' : 'No disponible'}
                    </span>
                  </div>
                  <div className='mobile-card-content'>
                    {a.areaVehicular === 'reparto' && (
                      <>
                        <div className='mobile-card-field'>
                          <div className='mobile-card-label'>Marca</div>
                          <div className='mobile-card-value'>{a.marca}</div>
                        </div>
                        <div className='mobile-card-field'>
                          <div className='mobile-card-label'>Modelo</div>
                          <div className='mobile-card-value'>{a.modelo}</div>
                        </div>
                        <div className='mobile-card-field'>
                          <div className='mobile-card-label'>Año</div>
                          <div className='mobile-card-value'>{a.anio}</div>
                        </div>
                        <div className='mobile-card-field'>
                          <div className='mobile-card-label'>Color</div>
                          <div className='mobile-card-value'>{a.color}</div>
                        </div>
                        <div className='mobile-card-field'>
                          <div className='mobile-card-label'>Capacidad</div>
                          <div className='mobile-card-value'>{a.capacidad || '—'}</div>
                        </div>
                        <div className='mobile-card-field'>
                          <div className='mobile-card-label'>Seguro</div>
                          <div className='mobile-card-value'>{a.seguro || '—'}</div>
                        </div>
                      </>
                    )}
                    {a.areaVehicular === 'proveedor' && (
                      <>
                        <div className='mobile-card-field'>
                          <div className='mobile-card-label'>Proveedor</div>
                          <div className='mobile-card-value'>{a.nombreProveedor || '—'}</div>
                        </div>
                        <div className='mobile-card-field'>
                          <div className='mobile-card-label'>Teléfono</div>
                          <div className='mobile-card-value'>{a.telefonoProveedor || '—'}</div>
                        </div>
                      </>
                    )}
                    {a.areaVehicular === 'empleado' && (
                      <>
                        <div className='mobile-card-field'>
                          <div className='mobile-card-label'>Empleado</div>
                          <div className='mobile-card-value'>{a.nombreEmpleado || '—'}</div>
                        </div>
                        <div className='mobile-card-field'>
                          <div className='mobile-card-label'>N° empleado</div>
                          <div className='mobile-card-value'>{a.numeroEmpleado || '—'}</div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className='mobile-card-actions'>
                    <button className='btn-editar' onClick={() => comenzarEdicion(a)}>Editar</button>
                    <button className='btn-eliminar' onClick={() => eliminarAuto(a)}>Eliminar</button>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default FormularioAutos;

